import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Text, TextTypes, Button, ButtonVariants } from '../../components/index';
import '../../styles/order-card.scss';
import CardDesktop from '../../components/card-detail/recipient/card-desktop';
import CardMobile from '../../components/card-detail/recipient/card-mobile';
import './card-detail.scss';
import Service from '../../services/apolloClient.service';
import { constants } from '../../constants';
import util from '../../util';
import styleLoader from '../../components/style-loader/style-loader';

interface OrderDetailProps {
    history: any;
    match: any;
    response: any;
}

function OrderDetail({ response, history }: OrderDetailProps) {
    const [card, setCard]: any = useState({});
    const [isRedemptionDisabled, setIsRedemptionDisabled] = useState(false);

    const getCardDetail = (card: any) => {
        const { cardsenderinfo, cardrecipientinfo } = card;
        const { sendername, senderemail } = cardsenderinfo;
        const { recipientname, recipientemail } = cardrecipientinfo;
        return {
            ...card,
            sendername,
            senderemail,
            recipientname,
            recipientemail,
        };
    };

    useEffect(() => {
        if (util.isEmpty(card) && !util.isEmpty(response)) {
            setCard(getCardDetail(response));
        }
    });

    // Check if we need to disable redemptions for certain merchants
    useEffect(() => {
        const disabledMerchants: string[] = constants.DISABLED_REDEMPTION_MERCHANTS.split(',');
        const merchantId: string = card?.merchant?.merchantId;

        setIsRedemptionDisabled(disabledMerchants.includes(merchantId));
    }, [card]);

    const setBalance = async (card: any) => {
        let res: any = await new Service().getBalance(card.clientcardsrno);
        if (res?.status === 0) {
            setCard({ ...card, balance: res.balance });
            return;
        }
        setCard({ ...card, balance: null });
    };

    const { group, merchant } = card;

    const link1 = () => (
        <a href={`${constants.USE_NOW_URL}/${merchant?.merchantId}`}>{group?.groupname}</a>
    );

    const link2 = () => {
        const urlCommon = `${constants.E_GIFT_CARD_URL}/${group?.groupId}/${merchant?.merchantId}`;
        const urlDesktop = `${urlCommon}/?source=web_merchant&returnUrl=${window.location.href}`;
        const urlMobile = `${urlCommon}/?source=olo_web&returnUrl=${window.location.href}`;
        return (
            <span style={{ display: 'inline-block' }}>
                <a href={urlDesktop} className="d-none d-md-block">
                    here
                </a>
                <a href={urlMobile} className="d-md-none d-sm-block">
                    here
                </a>
            </span>
        );
    };

    return (
        <Container fluid className="order card-detail">
            <Row>
                <Col className="d-flex page-title">
                    <div className="w-md-25">
                        <Text type={TextTypes.H2} className="d-none d-md-block mb-48">
                            Welcome, {card.recipientname}
                        </Text>
                        <Text type={TextTypes.H3} className="d-md-none d-sm-block">
                            Welcome <br /> {card.recipientname}
                        </Text>
                    </div>
                    <div className="d-none d-md-flex button-group">
                        <Button
                            onClick={() => {
                                card.balance > -1 &&
                                    history.push({ pathname: '/print', state: card });
                            }}
                            variant={ButtonVariants.SECONDARY}
                            className="print-btn"
                        >
                            Print
                        </Button>
                        {!isRedemptionDisabled && (
                            <Button
                                onClick={() => {
                                    window.open(
                                        `${constants.USE_NOW_URL}/${card.merchant?.merchantId}`
                                    );
                                }}
                                className="use-now"
                            >
                                Use Now
                            </Button>)}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="d-none d-md-block">
                    <Text type={TextTypes.SUB1} className="sub1">
                        Here is your e-Gift Card from {card.sendername}!
                    </Text>
                </Col>
                <Col className="d-md-none d-sm-block" style={{ textAlign: 'center' }}>
                    <Text type={TextTypes.P} className="sub1">
                        Here is your e-Gift Card from {card.sendername}
                    </Text>
                    {!isRedemptionDisabled && (
                        <Button
                            className="use-now"
                            onClick={() => {
                                window.open(`${constants.USE_NOW_URL}/${card.merchant?.merchantId}`);
                            }}
                        >
                            Use Now
                        </Button>
                    )}
                </Col>
            </Row>
            {card.carddetid && (
                <>
                    <Row className="order-md d-none d-md-flex">
                        <Col>
                            <CardDesktop
                                card={card}
                                setBalance={setBalance}
                                handlePrint={() => null}
                            />
                        </Col>
                    </Row>
                    <Row className="order-sm d-md-none d-sm-flex">
                        <Col>
                            <CardMobile
                                card={card}
                                setBalance={setBalance}
                                handlePrint={() => {
                                    card.balance > -1 &&
                                        history.push({ pathname: '/print', state: card });
                                }}
                            />
                        </Col>
                    </Row>
                </>
            )}

            {!isRedemptionDisabled && (
                <Row className="mb-48">
                    <Col>
                        <Text type={TextTypes.SUB1} className="d-none d-md-block mb-16 sub1">
                            How to use your e-Gift Card
                        </Text>
                        <Text type={TextTypes.SUB2} className="d-md-none d-sm-block mb-16 sub2-bold">
                            How to use your e-Gift Card
                        </Text>
                        <Text type={TextTypes.SUB2} className="mb-16 sub2-bold">
                            Online Ordering
                        </Text>
                        <Text type={TextTypes.P} className="mb-24 paragraph">
                            1. Visit {link1()} and start your order <br />
                            2. Redeem your e-Gift Card at checkout by entering your e-Gift Card number
                            <br />
                            3. Click Apply <br />
                            4. Your e-Gift Card balance will be deducted from your order total
                        </Text>
                        <Text type={TextTypes.SUB2} className="mb-8 sub2-bold">
                            Dine In
                        </Text>
                        <Text type={TextTypes.P} className="paragraph">
                            1. Place your order and mention your e-Gift Card before you pay <br />
                            2. Show the e-Gift Card number
                        </Text>
                    </Col>
                </Row>
            )}

            <Row className="d-md-none d-sm-flex">
                <Col style={{ textAlign: 'center' }}>
                    <Text type={TextTypes.SUB2} className="sub2-bold mb-8">
                        Give your e-Gift Card to someone
                    </Text>
                    <Text type={TextTypes.SUB2} className="sub2 mb-48">
                        You can email the current balance of this e-Gift Card to a new recipient.
                    </Text>
                </Col>
            </Row>
            <Row className="d-none d-md-flex">
                <Col style={{ textAlign: 'center' }} className="mb-16">
                    <Text type={TextTypes.SUB1} className="sub1">
                        Want to send an E-Gift Card? Click {link2()} to purchase
                    </Text>
                </Col>
            </Row>
            <Row className="d-md-none d-sm-flex mb-48">
                <Col style={{ textAlign: 'center' }}>
                    <Text type={TextTypes.SUB2} className="sub2-bold">
                        Want to send an E-Gift Card? Click {link2()} to purchase
                    </Text>
                </Col>
            </Row>
        </Container>
    );
}

const query = (params: any) => {
    const { clientcardsrno, carddetid } = params;
    return new Service().cardByRecipient(clientcardsrno, carddetid);
};

export default styleLoader(OrderDetail, query);
